module.exports = __webpack_public_path__ + "img/icon_benefit_06.865dc79f.svg";